import { type CalorimeterState, createCalorimeterScene } from './calorimeterScene';
import { LabCanvas3D } from './LabCanvas3D';

export type { CalorimeterState } from './calorimeterScene';

/**
 * Real-world view of the Explore setup: a lidded coffee-cup calorimeter (two nested polystyrene
 * cups, cut away at the front) with the solution level, thermometer and warm or cool cue from the
 * same state as the worked calculation.
 */
export function Calorimeter3D({ state, playing, label }: { state: CalorimeterState; playing: boolean; label: string }) {
  return <LabCanvas3D build={createCalorimeterScene} state={state} playing={playing} label={label} hint="Drag to turn the calorimeter" />;
}
